document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("index-swiper")) {
    class IndexSwiper extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector(".index-swiper-container");
        this.current_index = 0;
        this.youtube_list = this.querySelectorAll("[data-plyr-provider]");
        this.size = this.dataset.size;
        this.video_btn = this.querySelectorAll(".index-swiper-btn");
        this.swiper_obj = this.querySelector(".swiper");
        this.swiper = null;
        this.player_list = [];
        this.line_clamp=this.getAttribute("data-line_clamp")
        this.video_first_play=this.getAttribute("data-video_first_play")=='true'? true : false;
        const ua = navigator.userAgent || "";
        this.allow_fullscreen = !/iphone|ipad|ipod/i.test(ua);
      }
      connectedCallback() {
        this.detectObserver();
      }
      detectObserver() {
        let height = window.innerHeight / 2;
        if (this.container) {
          const resizeObserver = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                this.initDetectVideo();
                this.initSwiper();
                this.initVideoBtnClickEvent();
                if(this.line_clamp>0){
                  this.initLineClamp()
                }
                resizeObserver.disconnect();
              }
            },
            { threshold: 0, rootMargin: `${height}px 0px 0px 0px` }
          );
          resizeObserver.observe(this.container);
        }
      }
      initDetectVideo() {
        this.player_list = [];
        const plyrOpts = {
          controls: ["progress", "fullscreen"],
          tooltips: { controls: false, seek: false },
        };

        // YouTube：按 data-index 写入，避免与本地视频混排时索引错位
        for (let item of this.youtube_list) {
          const index = Number(item.dataset.index);
          if (Number.isNaN(index)) continue;
          this.player_list[index] = new Plyr(item, plyrOpts);
        }

        // New PC / Mb video（Shopify video → <video>）
        const nativeContainers = this.querySelectorAll(".common-video-index");
        for (let container of nativeContainers) {
          const index = Number(container.dataset.index);
          if (Number.isNaN(index) || this.player_list[index]) continue;
          const video = this.prepareNativeVideo(container);
          if (!video) continue;
          this.player_list[index] = new Plyr(video, plyrOpts);
        }

        this.playFirstVideo();
      }
      prepareNativeVideo(container) {
        const video =
          container.querySelector("video.common-lazy-video") ||
          container.querySelector("video.pc-video") ||
          container.querySelector("video");
        if (!video) return null;

        const lazyRoot = container.querySelector(".shopify-lazy-common-video");
        if (lazyRoot) {
          const isMb = window.innerWidth < 850;
          const pcSrc = lazyRoot
            .querySelector(".pc-video-box video source")
            ?.getAttribute("data-src");
          const mbSrc = lazyRoot
            .querySelector(".mb-video-box video source")
            ?.getAttribute("data-src");
          const src = mbSrc && isMb ? mbSrc : pcSrc;
          const poster =
            (isMb && lazyRoot.dataset.mbPoster) ||
            lazyRoot.dataset.pcPoster ||
            "";
          if (poster) {
            video.setAttribute("poster", poster);
            const posterImg = video.querySelector("img");
            if (posterImg) posterImg.src = poster;
          }
          if (src) {
            video.src = src;
            video.querySelectorAll("source").forEach((source) => {
              source.src = src;
              source.removeAttribute("data-src");
            });
            video.removeAttribute("data-src");
            video.style.opacity = "1";
            video.setAttribute("data-loaded", "true");
            try {
              video.load();
            } catch (e) {}
          }
        } else {
          video.querySelectorAll("source[data-src]").forEach((source) => {
            source.src = source.getAttribute("data-src");
            source.removeAttribute("data-src");
          });
        }

        return video;
      }
      initSwiper() {
        if (!this.swiper_obj) return;
        const slider_pc_num = this.getAttribute("data-swiper_pc_num")
          ? this.getAttribute("data-swiper_pc_num")
          : 1;
        const slider_ipad_num = this.getAttribute("data-swiper_ipad_num")
          ? this.getAttribute("data-swiper_ipad_num")
          : slider_pc_num;
        const slider_m_num = this.getAttribute("data-swiper_m_num")
          ? this.getAttribute("data-swiper_m_num")
          : slider_ipad_num;
        const prevButton = this.querySelector(".swiper-button-prev");
        const nextButton = this.querySelector(".swiper-button-next");
        const scrollbar = this.querySelector(".swiper-scrollbar");
        const pagination = this.querySelector(".swiper-pagination");
        const swiper_auto=this.getAttribute("data-swiper_auto")=='true'?true:false
        const swiper_auto_time=this.getAttribute("data-swiper_auto_time") * 1
        const loop= this.getAttribute("data-swiper_loop")=='true' ? true : false
        const speed= this.getAttribute("data-swiper_speed") * 1000
        let autoplay = false
        if(swiper_auto){
          autoplay = {
              delay: swiper_auto_time,
              stopOnLastSlide: false,
              disableOnInteraction: true,
            }
        }
        this.swiper = new Swiper(this.swiper_obj, {
          slidesPerView: slider_pc_num,
          spaceBetween: 20,
          autoplay:autoplay,
          loop:loop,
          speed: speed , 
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
          breakpoints: {
            1024: {
              spaceBetween: 15,
              slidesPerView: slider_ipad_num,
            },
            589: {
              spaceBetween: 10,
              slidesPerView: slider_m_num,
            },
          },
        });
      }
      initVideoBtnClickEvent() {
        for (let btn_item of this.video_btn) {
          btn_item.addEventListener("click", () => {
            const index = Number(btn_item.dataset.index);
            if (Number.isNaN(index)) return;
            const flag =
              btn_item.getAttribute("data-video_fullscreen") == "true";
            const currentIndex = Number(this.current_index);
            const player = this.player_list[index];
            if (!player) return;

            // Enable Click FullScreen：页面只留 poster，点击用固定层全屏播放
            if (flag) {
              const videoContainer = btn_item.closest(".video-container");
              if (videoContainer?.classList.contains("is-fs-open")) {
                this.resetToPoster(index);
                return;
              }
              if (currentIndex !== index && this.video_btn[currentIndex]) {
                this.resetToPoster(currentIndex);
              }
              this.openFullscreenPlay(index);
              return;
            }

            // 未开启全屏：卡片内播放 / 暂停
            const isCurrent = currentIndex === index;
            const isPlaying = !player.paused;
            if (isCurrent && isPlaying) {
              this.pauseVideoFn(index);
              return;
            }
            if (!isCurrent && this.video_btn[currentIndex]) {
              this.pauseVideoFn(currentIndex);
            }
            this.playVideoFn(index);
          });
        }
      }
      openFullscreenPlay(index) {
        const player = this.player_list[index];
        const btn = this.video_btn[index];
        if (!player || !btn) return;
        const videoContainer = btn.closest(".video-container");
        this.current_index = index;
        btn.classList.add("active");
        btn.closest(".index-swiper-item")?.classList.add("active");
        if (videoContainer) videoContainer.classList.add("is-fs-open");

        // 播放器挪到 body，避开胶囊 clip-path / overflow
        const mediaWrap = videoContainer?.querySelector(
          ".common-video-index, .youtube-index"
        );
        if (mediaWrap && mediaWrap.parentElement !== document.body) {
          this._fsPlaceholder = document.createComment("index-swiper-fs");
          mediaWrap.parentNode.insertBefore(this._fsPlaceholder, mediaWrap);
          mediaWrap.classList.add("index-swiper-fs-layer");
          document.body.appendChild(mediaWrap);
          this._fsMediaWrap = mediaWrap;
        }

        let closeBtn = document.body.querySelector(".index-swiper-fs-close");
        if (!closeBtn) {
          closeBtn = document.createElement("button");
          closeBtn.type = "button";
          closeBtn.className = "index-swiper-fs-close";
          closeBtn.setAttribute("aria-label", "Close video");
          closeBtn.textContent = "×";
          document.body.appendChild(closeBtn);
        }
        closeBtn.onclick = (e) => {
          e.stopPropagation();
          this.resetToPoster(index);
        };

        player.muted = false;
        player.volume = 1;
        const playPromise = player.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }

        const onKey = (e) => {
          if (e.key === "Escape") this.resetToPoster(index);
        };
        if (this._fsEscHandler) {
          document.removeEventListener("keydown", this._fsEscHandler);
        }
        this._fsEscHandler = onKey;
        document.addEventListener("keydown", onKey);
      }
      resetToPoster(index) {
        const player = this.player_list[index];
        if (!this.video_btn[index]) return;
        const videoContainer = this.video_btn[index].closest(".video-container");
        if (videoContainer) videoContainer.classList.remove("is-fs-open");

        if (this._fsMediaWrap && this._fsPlaceholder?.parentNode) {
          this._fsPlaceholder.parentNode.insertBefore(
            this._fsMediaWrap,
            this._fsPlaceholder
          );
          this._fsPlaceholder.remove();
          this._fsMediaWrap.classList.remove("index-swiper-fs-layer");
          this._fsMediaWrap = null;
          this._fsPlaceholder = null;
        }
        document.body.querySelector(".index-swiper-fs-close")?.remove();

        if (this._fsEscHandler) {
          document.removeEventListener("keydown", this._fsEscHandler);
          this._fsEscHandler = null;
        }
        this.video_btn[index].classList.remove("active");
        this.video_btn[index]
          .closest(".index-swiper-item")
          ?.classList.remove("active");
        if (player) {
          if (!player.paused) player.pause();
          try {
            player.currentTime = 0;
          } catch (e) {}
          player.muted = true;
        }
      }
      playVideoFn(play_index) {
        const index = Number(play_index);
        if (Number.isNaN(index) || !this.video_btn[index]) return;
        this.current_index = index;
        this.video_btn[index].classList.add("active");
        this.video_btn[index]
          .closest(".index-swiper-item")
          .classList.add("active");
        this.player_list[index] &&
          this.player_list[index].paused &&
          this.player_list[index].play();
      }
      pauseVideoFn(pause_index) {
        const index = Number(pause_index);
        if (Number.isNaN(index) || !this.video_btn[index]) return;
        this.video_btn[index].classList.remove("active");
        this.video_btn[index]
          .closest(".index-swiper-item")
          .classList.remove("active");
        this.player_list[index] &&
          !this.player_list[index].paused &&
          this.player_list[index].pause();
      }
      playFirstVideo() {
        // 全屏 poster 模式：不自动播，页面只留封面
        const firstBtn = this.video_btn[0];
        if (
          firstBtn &&
          firstBtn.getAttribute("data-video_fullscreen") == "true"
        ) {
          return;
        }
        let flag =
          firstBtn && firstBtn.getAttribute("data-video_loop") == "true"
            ? true
            : false;
        const player = this.player_list[0];
        if (player) {
          const setup = () => {
            player.muted = true;
            player.volume = 0;
            if (flag) {
              player.loop = { active: true };
            }
            if (this.video_first_play) {
              this.playVideoFn(0);
            }
          };
          if (player.media && player.media.readyState >= 1) {
            setup();
          } else {
            player.on("ready", setup);
          }
        }
        if (!flag) this.detectLoopVideo();
      }
      detectLoopVideo() {
        const size = Number(this.size) || this.player_list.length;
        for (let j = 0; j < size; j++) {
          const player = this.player_list[j];
          if (!player) continue;
          player.on("ended", () => {
            this.pauseVideoFn(j);
            if (j + 1 < size && this.player_list[j + 1]) {
              this.swiper && this.swiper.slideTo(j + 1);
              this.playVideoFn(j + 1);
            }
          });
        }
      }
      initLineClamp(){
        const all_ele=this.querySelectorAll(".ellipsis-content")
        const btn_ele=this.querySelectorAll(".index-linka")
        if(!all_ele || !btn_ele) return ;
        const single_h=getComputedStyle(this.querySelector(".ellipsis-content")).lineHeight.replace("px","")
        const three_h = Math.ceil(single_h * 3)   
        for (let all_item of all_ele) {
           let content_h= Math.ceil(all_item.offsetHeight)
           if(content_h > three_h){
              all_item.classList.add("text-ellipsis")
           }else{
             all_item.closest(".content").classList.add("no-more")
           }
        }
        for(let btn_item of btn_ele){
           btn_item.addEventListener("click", () => {
               if(btn_item.closest(".content").classList.contains("active")){
                 btn_item.innerText='Dowiedz się więcej'
               }else{
                 btn_item.innerText='Learn Less'
               }
               btn_item.closest(".content").classList.toggle("active")

           })
        }
      }
    }
    customElements.define("index-swiper", IndexSwiper);
  }
});
